import { useEffect, useState } from "react";
import axios from "axios";
import { Pencil } from "lucide-react";
import "../../styles/settings/GeneralSettings.css";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/general-setting`;

const GeneralSettings = () => {
  const [settings, setSettings] = useState([]);
  const token = localStorage.getItem("token");

  const [showModal, setShowModal] = useState(false);
  const [currentSetting, setCurrentSetting] = useState(null);
  const [newValue, setNewValue] = useState("");

  /* ================= LOAD ================= */
  const loadSettings = async () => {
    try {
      const res = await axios.get(API_URL, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSettings(res.data);
    } catch (err) {
      console.error("Load settings failed", err);
    }
  };

  useEffect(() => {
    loadSettings();
  }, []);

  /* ================= OPEN EDIT ================= */
  const openEdit = (item) => {
    setCurrentSetting(item);
    setNewValue(item.setting_value);
    setShowModal(true);
  };

  /* ================= SAVE ================= */
  const handleSave = async () => {
    if (!newValue.trim()) return;

    try {
      await axios.put(
        `${API_URL}/${currentSetting.setting_id}`,
        { setting_value: newValue },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setShowModal(false);
      loadSettings();
    } catch (err) {
      alert("Operation failed");
    }
  };

  /* ================= CANCEL ================= */
  const handleCancel = () => {
    setShowModal(false);
    setCurrentSetting(null);
    setNewValue("");
  };

  return (
    <div className="settings-page">
      {/* ✅ COMMON SETTINGS HEADER */}
      <div className="settings-header">
        <h2>General Settings</h2>
      </div>

      {/* ✅ COMMON SETTINGS TABLE */}
      <table className="settings-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Setting Name</th>
            <th>Setting Value</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {settings.map((s) => (
            <tr key={s.setting_id}>
              <td>{s.setting_id}</td>
              <td>{s.setting_name}</td>
              <td>{s.setting_value}</td>

              <td>
                <button
                  className="action-btn"
                  onClick={() => openEdit(s)}
                  title="Edit"
                >
                  <Pencil size={16} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* MODAL (UNCHANGED) */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Edit Setting</h3>

            <div className="field">
              <label>Setting Name</label>
              <p className="readonly">{currentSetting.setting_name}</p>
            </div>

            <div className="field">
              <label>Value</label>
              <input
                value={newValue}
                onChange={(e) => setNewValue(e.target.value)}
              />
            </div>

            <div className="modal-actions right">
              <button className="secondary-btn" onClick={handleCancel}>
                Cancel
              </button>
              <button className="primary-btn" onClick={handleSave}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GeneralSettings;
